
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Renders a price with a tag for each part to allow all sorts of styling.
 */
@Component({
  name: 'Price',
})
export default class extends Vue {
  @Prop({ required: true })
  value

  get parts() {
    return this.formatCurrencyParts(this.value)
  }

  get currencySymbol() {
    return this.parts[0]
  }

  get integerPart() {
    return this.parts[1]
  }

  get fractionalPart() {
    // TODO Decimal symbol is not the same in all locales.
    return '.' + this.parts[2]
  }

  get isFree() {
    return this.value === 0
  }
}
